// extracted by mini-css-extract-plugin
export var container = "_6q-0";
export var containerTopRight = "_6q-1";